import { createRoot, hydrateRoot } from "react-dom/client";
import "./index.css";
import i18n from "./i18n";
import { initConsent } from "./lib/cookieConsent";
import App from "./App.tsx";

// Google Tag Manager only loads after the visitor accepts cookies
initConsent();

// The language in the URL always wins, so hydration matches the prerendered HTML
const urlLang = window.location.pathname.match(/^\/(es|en|it|de|fr)(?=\/|$)/)?.[1];
if (urlLang && i18n.language?.substring(0, 2) !== urlLang) i18n.changeLanguage(urlLang);

const root = document.getElementById("root")!;
if (root.hasChildNodes()) {
  hydrateRoot(root, <App />);
} else {
  createRoot(root).render(<App />);
}
